export default __webpack_public_path__ + "static/media/logo_kulinarne.787c1ef9.png";